import { lazy, Suspense, useEffect } from 'react';
import Lenis from 'lenis';
import '@/App.css';
import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
import CustomCursor from '@/components/CustomCursor';

const About       = lazy(() => import('@/components/About'));
const Services    = lazy(() => import('@/components/Services'));
const ClientCases = lazy(() => import('@/components/ClientCases'));
const Pricing     = lazy(() => import('@/components/Pricing'));
const Testimonials= lazy(() => import('@/components/Testimonials'));
const FAQ         = lazy(() => import('@/components/FAQ'));
const Contact     = lazy(() => import('@/components/Contact'));
const Footer      = lazy(() => import('@/components/Footer'));

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  return (
    <div className="app-wrapper">
      <CustomCursor />
      <Navigation />
      <main>
        <Hero />
        <Suspense fallback={null}><About /></Suspense>
        <Suspense fallback={null}><Services /></Suspense>
        <Suspense fallback={null}><ClientCases /></Suspense>
        <Suspense fallback={null}><Pricing /></Suspense>
        <Suspense fallback={null}><Testimonials /></Suspense>
        <Suspense fallback={null}><FAQ /></Suspense>
        <Suspense fallback={null}><Contact /></Suspense>
      </main>
      <Suspense fallback={null}><Footer /></Suspense>
    </div>
  );
}

export default App;
